import { render } from "./App.vue?vue&type=template&id=24b5879a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=24b5879a&lang=scss"

import exportComponent from "/Users/dracoghost/Documents/ProyectosFunkoPopMorelia/funkopopmorelia-catalogo-vue-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__